module.exports = __webpack_public_path__ + "static/media/restApi.04776e9f.svg";